export const mapBeneficiarioToRequest = (idSolicitud, beneficiario, usuario) => {
    return {
        usuario                       : usuario,
        idBeneficiario                : beneficiario.idBeneficiario,
        idSolicitud                   : idSolicitud,
        tipoBeneficiario              : beneficiario.tipoBeneficiario,
        nombres                       : beneficiario.nombres,
        apellidoPaterno               : beneficiario.apellidoPaterno,
        apellidoMaterno               : beneficiario.apellidoMaterno,
        parentesco                    : beneficiario.parentesco,
        tipoDocumento                 : !beneficiario.tipoDocumento ? { "tipoDocumento": { "codigo": 0, "descripcion": "" }} : beneficiario.tipoDocumento,
        numeroDocumento               : !beneficiario.numeroDocumento ? "" : beneficiario.numeroDocumento,
        sexo                          : beneficiario.sexo,
        fechaNacimiento               : beneficiario.fechaNacimiento,
        porcentajeBeneficio           : beneficiario.porcentajeBeneficio,
        tutor                         : beneficiario.tutor,
        indicadorModificacionDatosPID : beneficiario.indicadorModificacionDatosPID
    }
}